// extracted by mini-css-extract-plugin
module.exports = {"right":"SideHero_right__7Mqpu","heroBox":"SideHero_heroBox__Xn39a","overlay":"SideHero_overlay__fqlwX","overlayTitle":"SideHero_overlayTitle__WMISr","line":"SideHero_line__CXB8k"};